import { OrderGetResponseType } from "@sellar-io/api-v2/types";

export type OrderFulfillmentBadgeType =
  | "Direct"
  | "Courier"
  | "Collection"
  | "Pallet"
  | "UPS"
  | "APC"
  | "Courier Pro"
  | "DX (Collection)"
  | "DX (Drop Off Point)"
  | "Parcelforce"
  | "Delivered by Sellar"
  | "Sellar Distribution";

export const getOrderFulfillmentBadgeType = ({
  fulfillmentType,
  isSupplier,
}: {
  fulfillmentType: OrderGetResponseType["fulfillmentType"] | null;
  isSupplier: boolean;
}): OrderFulfillmentBadgeType => {
  switch (fulfillmentType) {
    case "courier":
      return "Courier";
    case "haulier":
      return "Pallet";
    case "collection":
      return "Collection";
    case "parcelforce":
      return isSupplier ? "Parcelforce" : "Courier";
    case "ups":
      return isSupplier ? "UPS" : "Courier";
    case "apc":
      return isSupplier ? "APC" : "Courier";
    case "dxBasic":
    case "dx":
      return isSupplier ? "DX (Collection)" : "Courier";
    case "dxDropOff":
      return isSupplier ? "DX (Drop Off Point)" : "Courier";
    case "sellarDistribution":
      return isSupplier ? "Sellar Distribution" : "Delivered by Sellar";
    default:
      return "Direct";
  }
};
